<template>
  <section class="bg-white">
    <b-container
      v-if="isLoading"
      id="loading-animation my-auto"
    >
      <b-row class="justify-content-md-center py-3">
        <h3 class="text-xl md:text-2xl text-green-900 font-bold">
          Loading...
        </h3>
      </b-row>
      <b-row class="justify-content-md-center py-3">
        <b-spinner
          variant="primary"
          label="Loading"
          style="width: 5vw; height: 5vw;"
        />
      </b-row>
    </b-container> 
    <div
      v-else-if="whitelisted"
      class="container mx-auto"
    >
      <span class="inline-block py-px px-2 mb-4 text-xs leading-5 text-green-500 bg-green-100 font-medium uppercase rounded-9xl">
        Pricing</span>
      <h3 class=" mb-4 text-3xl md:text-5xl text-green-500 font-bold tracking-tighter">
        Premium partner plan
      </h3>
      <p class="text-lg md:text-xl font-semibold">
        You are currently enjoying a premium plan provided by Zimmer and Peacock
      </p>
      <a
        href="https://www.zimmerpeacock.com/"
        target="_blank"
        class="logo-zp"
      >
        <img
          id="zpLogo"
          alt="ZPLogo"
          src="../../assets/MainMenu/LogoZP.png"
          class="img-fluid w-25 my-5 mx-auto d-block"
        >
      </a>
    </div>
    <div
      v-else-if="!!subscriptionList"
      class="pt-10 xl:pt-10 xl:pb-16"
    >
      <div class="container mx-auto">
        <span
          class="inline-block py-px px-2 mb-4 text-xs leading-5 text-green-500 bg-green-100 font-medium uppercase rounded-9xl"
        >Pricing</span>
        <h3
          v-if="freemium_access_type"
          class=" mb-4 text-3xl md:text-5xl text-green-500 font-bold tracking-tighter"
        >
          You are currently subscribed to Free plan.
        </h3>
        <h3
          class=" mb-4 text-3xl md:text-5xl text-coolGray-900 font-bold tracking-tighter"
        >
          Flexible pricing for your electrochemical sensor data needs.
        </h3>
        <p class="mb-12 text-lg md:text-xl text-coolGray-500 font-medium">
          Pricing that scales with your research rapidly.
          <b-button
            class="bg-green-500"
            variant="primary"
            @click="toggleCollapse"
          >
            <b-icon :icon="isOpen ? 'caret-up-fill' : 'caret-down-fill'" />{{ isOpen ? 'Hide Subscription Types' : 'See Subscription Types' }}
          </b-button>
        </p>
        <b-collapse
          v-model="isOpen"
          class="mt-2"
          @collapsed="onCollapsed"
          @expanded="onExpanded"
        >
          <div class="col-sm-12 col-md-8 mx-auto">
            <b-card class="p-0">
              <b-card-header class="d-flex align-items-center pt-3 bg-green-500">
                <b-card-title class="h5 mb-0 mx-auto">
                  <span class="text-white text-center">DJULI-FREEMIUM VERSUS PREMIUM SUBSCRIPTIONS</span>
                </b-card-title>
              </b-card-header>
              <b-card-body class="text-justify p-1">
                <b-table
                  responsive
                  bordered
                  small
                  :items="items"
                  :fields="fields"
                  :tbody-tr-class="rowClass"
                />
              </b-card-body>
            </b-card>
          </div>
        </b-collapse>
        <p
          v-if="subscriptionList.data && subscriptionList.data.length > 0"
          class="text-lg md:text-xl text-red-500 font-semibold"
        >
          You already have an active subscription plan.
        </p>
        <div
          v-else
          class="flex flex-wrap justify-center -mx-4"
        >
          <div class="flex flex-wrap justify-center -mx-4">
            <div
              v-if="!freemium_access_type"
              class="flex flex-col items-center pt-10 px-8 pb-8 bg-coolGray-50 rounded-md shadow-md hover:scale-105 transition duration-500"
            >
              <span class="inline-block py-px px-2 mb-6 text-xs leading-5 text-green-500 bg-green-100 font-medium uppercase rounded-9xl">Pricing</span>
              <h3 class="mb-4 text-lg md:text-2xl text-green-500 font-medium">
                Start
              </h3>
              <div class="mb-4">
                <span class="relative -top-6 right-1 text-3xl text-coolGray-900 font-medium">Free</span>
                <span class="text-5xl text-coolGray-900 font-medium" />
              </div>
              <div class="mb-7 text-lg md:text-xl text-coolGray-400 font-medium">
                <p>No Credit Card needed</p>
              </div>
              <ul class="self-start mb-8">
                <li
                  class="flex items-center mb-3 text-coolGray-500 font-medium"
                >
                  <img
                    class="mr-3"
                    src="../../assets/Images/checkbox-green.png"
                  >
                  <span>Complete documentation</span>
                </li>
                <li
                  class="flex items-center mb-3 text-coolGray-500 font-medium"
                >
                  <img
                    class="mr-3"
                    src="../../assets/Images/checkbox-green.png"
                  >
                  <span>Real time data analysis</span>
                </li>
                <li
                  class="flex items-center mb-3 text-coolGray-500 font-medium"
                >
                  <img
                    class="mr-3"
                    src="../../assets/Images/checkbox-green.png"
                  >
                  <span>Unlimited cloud storage</span>
                </li>
                <li class="flex items-center text-coolGray-500 font-medium">
                  <img
                    class="mr-3"
                    src="../../assets/Images/checkbox-green.png"
                  >
                  <span>Limited access to features</span>
                </li>
              </ul>
              <button
                class="inline-block py-3 px-7 w-full text-green-50 font-medium text-center bg-green-500 hover:bg-green-600 focus:ring-2 focus:ring-green-500 focus:ring-opacity-50 rounded-md shadow-sm"
                @click="subscribeToFreemium('freemium')"
              >
                Subscribe to Freemium
              </button>
            </div>
          </div>
          <div
            v-for="(plan, index) in subscrtionplans"
            :key="index"
            :class="freemium_access_type ? 'lg:w-1/3' : 'lg:w-1/4'"
            class="w-full md:w-1/2 p-4"
          >
            <div
              class="
                flex flex-col
                items-center
                pt-10
                px-8
                pb-8
                bg-white
                rounded-md
                shadow-md
                hover:scale-105
                transition
                duration-500
              "
            >
              <span
                class="
                  inline-block
                  py-px
                  px-2
                  mb-6
                  text-xs
                  leading-5
                  text-green-500
                  bg-green-100
                  font-medium
                  uppercase
                  rounded-9xl
                "
              >Pricing</span>
              <h3 class="mb-4 text-lg md:text-xl text-green-500 font-medium">
                {{ plan.metadata.name }}
              </h3>
              <div class="mb-4">
                <span
                  class="
                    relative
                    -top-6
                    right-1
                    text-2xl text-coolGray-900
                    font-medium
                  "
                >€</span>
                <span class="text-5xl text-coolGray-900 font-medium">{{
                  plan.amount / 100
                }}</span>
                <span
                  v-if="plan.metadata.name.split(' ')[0] === 'Monthly'"
                  class="text-3xl text-coolGray-900 font-medium"
                >/mo</span>
                <span
                  v-if="plan.metadata.name.split(' ')[0] === 'Half'"
                  class="text-3xl text-coolGray-900 font-medium"
                >/hy</span>
                <span
                  v-if="plan.metadata.name.split(' ')[0] === 'Yearly'"
                  class="text-3xl text-coolGray-900 font-medium"
                >/yr</span>
              </div>
              <div
                class="mb-7 text-lg md:text-xl text-coolGray-400 font-medium"
              >
                <p v-if="plan.metadata.name.split(' ')[0] === 'Monthly'">
                  Billed Monthly
                </p>
                <p v-if="plan.metadata.name.split(' ')[0] === 'Half'">
                  Billed Half Yearly
                </p>
                <p v-if="plan.metadata.name.split(' ')[0] === 'Yearly'">
                  Billed Yearly
                </p>
              </div>
              <ul class="self-start mb-8">
                <li
                  class="flex items-center mb-3 text-coolGray-500 font-medium"
                >
                  <img
                    class="mr-3"
                    src="../../assets/Images/checkbox-green.png"
                  >
                  <span>Complete documentation</span>
                </li>
                <li
                  class="flex items-center mb-3 text-coolGray-500 font-medium"
                >
                  <img
                    class="mr-3"
                    src="../../assets/Images/checkbox-green.png"
                  >
                  <span>Real time data analysis</span>
                </li>
                <li
                  class="flex items-center mb-3 text-coolGray-500 font-medium"
                >
                  <img
                    class="mr-3"
                    src="../../assets/Images/checkbox-green.png"
                  >
                  <span>Unlimited cloud storage</span>
                </li>
                <li class="flex items-center text-coolGray-500 font-medium">
                  <img
                    class="mr-3"
                    src="../../assets/Images/checkbox-green.png"
                  >
                  <span>Share data between users</span>
                </li>
              </ul>
              <button
                class="
                  inline-block
                  py-3
                  px-7
                  w-full
                  text-green-50
                  font-medium
                  text-center
                  bg-green-500
                  hover:bg-green-600
                  focus:ring-2 focus:ring-green-500 focus:ring-opacity-50
                  rounded-md
                  shadow-sm
                "
                :disabled="
                  subscriptionList.data && subscriptionList.data.length > 0
                "
                :class="{
                  'bg-gray-400 hover:bg-gray-600':
                    subscriptionList.data && subscriptionList.data.length > 0,
                }"
                @click="collectPlan(plan)"
              >
                Select plan
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Vuex from 'vuex';

export default {
  data() {
    return {
      isLoading: false,
      freemium_access_type: true,
			showPriceSummary: false,
			isOpen: false,
			anchorValue:'Click here',
			fields: [{key:'feature',label:'Feature', class: 'bg-coolGray-50'}, {key:'freemium', label:'Freemium'}, {key:'premium', label:'Full access-Premium'}],
			items: [
				{ feature: 'Price', freemium: 'Free', premium: '99€ per month' },
				{ feature: 'No. of Reports', freemium: '5-3 samples (pre-built)', premium: 'unlimited' },
				{ feature: 'Tools', freemium: '✓', premium: '✓' },
				{ feature: 'Export Reports', freemium: '✓', premium: '✓' },
				{ feature: 'Template', freemium: ' ', premium: '✓' },
				{ feature: 'AC', freemium: '✓', premium: '✓' },
				{ feature: 'PC', freemium: '✓', premium: '✓' },
				{ feature: 'Generic', freemium: '✓', premium: '✓' },
				{ feature: 'Download raw data', freemium: ' ', premium: '✓' },
				{ feature: 'Download analysis results', freemium: '✓', premium: '✓' },
				{ feature: 'Delete report', freemium: ' ', premium: '✓' },
				{ feature: 'Make new report', freemium: 'Only 2 (sample project + 1 more)', premium: '✓' },
				{ feature: 'Edit a report - save changes', freemium: ' ', premium: '✓' },
				{ feature: 'Create a cluster', freemium: ' ', premium: '✓' },
				{ feature: 'Comparative reports', freemium: 'If less than 5 reports it will probably work', premium: '✓' }
			]
    };
  },
  computed: {
    ...Vuex.mapGetters({
      subscrtionplans: 'subscription/listSubscriptionPlans',
      isAuthenticatedMiddlewareAuth: 'isAuthenticatedMiddlewareAuth',
      subscriptionList: 'subscription/subscriptionList',
      whitelisted: 'subscription/whitelisted',
    }),
  },
  async created() {
    this.isLoading = true
    let freemium_access = await this.freemium_access();
    this.freemium_access_type = freemium_access.not_allowed;
    let fetch_plan_status = await this.fetchAllPlanDetails();
    if (!fetch_plan_status) {
      await this.$alert(
        'Error fetching plans information. Please try again in few seconds.',
        'Error',
        'error'
      );
    }
    let active_subscription_status = await this.listsubscription();
    if (!active_subscription_status) {
      await this.$alert(
        'Error fetching active subscription information. Please try again in few seconds.',
        'Error',
        'error'
      );
    }
    this.isLoading = false
  },
  methods: {
    ...Vuex.mapActions({
      fetchAllPlanDetails: 'subscription/listAllPlans',
      showSelectedPlan: 'subscription/userBasedPlanDetails',
      listsubscription: 'subscription/listsubscription',
      freemium_access: 'subscription/validate_access_freemiumplan',
      subscribe_freemium:'subscription/subscribe_freemium'
    }),

    async subscribeToFreemium(){
     let status= await this.subscribe_freemium({
        freemium:true
      })

      if(!status){
         await this.$alert(
            'Error while select the plan. Please try again in few seconds.',
            'Error',
            'error'
          );
          return;
      }

    },

    async collectPlan(plan) {
      if (!this.isAuthenticatedMiddlewareAuth) {
        const formattedName = plan.metadata.name.replace(' ', '-').toLowerCase()
        this.$router.push(`/register/${formattedName}`);
      } else {
        let selected_plan_payload = {
          product_id: plan.product,
          plan_type: plan.metadata.name,
        };
        let status = await this.showSelectedPlan(selected_plan_payload);
        if (!status) {
          await this.$alert(
            'Error while select the plan. Please try again in few seconds.',
            'Error',
            'error'
          );
          return;
        }
        this.$router.push('/choosenplan');
      }
    },
		rowClass(item, type) {
        if (!item || type !== 'row') return
        if (item.status === 'awesome') return 'table-success'
    },
		onCollapsed() {
      this.anchorValue = 'Click here';
    },
    onExpanded() {
      this.anchorValue = 'Hide price summary';
    },
		toggleCollapse() {
      this.isOpen = !this.isOpen;
    },
  },
};
</script>

<style scoped>
ul {
  text-align: center;
  justify-content: center;
  display: flex;
  margin: auto;
  flex-direction: column;
  padding-bottom: 2rem;
}
.text-green {
  color: green;
}

a:hover {
  cursor: pointer !important;
}
.custom-table thead th {
  background-color: green;
  color: white;
}
.b-table td {
  padding: 0.2rem 0.5rem !important; /* Adjust the padding to reduce cell height */
}

@media (max-width: 768px) {
  .b-table td {
    font-size: 1.5vw !important; /* Use 'vw' for responsive font size */
  }
}
</style>
